<section class="simulation grid-container login-page">
    <div>
        <div class="page-header">
            <p class="simulation__panelTitle page-title">{{ 'reset.username.title' | i18n }}</p>
        </div>
        <div class="login-page__content">
            <div class="login-page__resetusername">
                <img class="introduction__imagepe" alt="" [appAssetSrc]="'assets/images/signature-error.svg'" />
                <h3 id="forgot_login_subtitle">{{ 'reset.username.subtitle' | i18n }}</h3>
                <p id="forgot_login_message">{{ 'reset.username.text' | i18n }}</p>
                <button id="go_back_btn" type="button" class="grid-6 push-3 grid-mobile-4 push-mobile-0 button button--primary" routerLink="/connexion">
                    {{ 'reset.username.button' | i18n }}
                </button>
            </div>
        </div>
    </div>
</section>
